







































































































































import {Component, Vue} from 'vue-property-decorator';
import moment from 'moment-timezone';
import {TicketStore} from '@/store/modules/ticket.store';
import { find } from 'lodash';
// import {find} from 'lodash/find'
import Badge from '@/components/Badge.vue';
import PaidBill from '@/components/PaidBill.vue';
// @ is an alias to /src

@Component({
	components: {
		badge: Badge,
		'paid-bill': PaidBill
	}
})
export default class ActiveTickets extends Vue {
	fields = [
		// {
		// 	key: 'table',
		// 	label: 'Table',
		// 	sortable: true
		// },
		{
			key: 'table',
			label: 'Table',
			sortable: true,
			sortByFormatted: (table: any) => {
				return table ? table : '';
			}
		},
		{
			key: 'customerPhone',
			label: 'Customer',
			sortable: true
		},
		{
			key: 'status',
			label: 'Status',
			sortable: true
		},
		{
			key: 'amount',
			label: 'Amount',
			sortable: true
		},
		{
			key: 'paidAmount',
			label: 'Paid',
			sortable: true
		},
		{
			key: 'tipAmount',
			label: 'Tip',
			sortable: true
		},
		{
			key: 'time',
			label: 'Time',
			sortable: true,
			sortDirection: 'asc',
			sortByFormatted: (time: any) => {
				return this.getSecondsAgo(time);
			}
		},
	];
	showBadge = false;
	showPaidBill = false;
	clickedTicketId: string | null = null;
	sortBy = 'time';
	sortDesc = true;

	get activeTickets() {
		const tickets = TicketStore.active.map((ticket) => {
			let paidAmount = 0;
			let tipAmount = 0;
			if(ticket.payments?.length) {
				ticket.payments.forEach((payment) => {
					paidAmount += payment.amount;
					tipAmount += Number(payment.gratuity);
				});
			}

			return {
				ticketId: ticket.ticketId,
				table: ticket.tableName,
				badgeId: ticket.badgeId,
				customerPhone: ticket.customer.phone,
				customerName: ticket.customer.name,
				status: ticket.state.substring(0, 1) + ticket.state.substring(1).toLowerCase(),
				amount: ticket.total,
				paidAmount: paidAmount === 0 ? null : paidAmount,
				tipAmount: tipAmount === 0 ? null : tipAmount,
				time: ticket.openedDate
			};
		}).sort((a, b) => {
			const field = find(this.fields, {key: this.sortBy}) as unknown as {
				key: 'table' | 'customerPhone' | 'status' | 'amount' | 'paidAmount' | 'tipAmount' | 'time';
				sortByFormatted: () => any
			};
			const compareFn = field.sortByFormatted ? field.sortByFormatted : (value: any) => {
				return value;
			};
			const aValue = compareFn(a[field.key]);
			const bValue = compareFn(b[field.key]);
			if(aValue < bValue) {
				return -1;
			} else if(aValue > bValue) {
				return 1;
			}
			return 0;
		});
		return this.sortDesc ? tickets.reverse() : tickets;
	}

	ticketClicked(ticket: any) {
		this.clickedTicketId = ticket.ticketId;
		if(ticket.status === 'Paid') {
			this.showPaidBill = true;
		} else {
			this.showBadge = true;
		}
	}

	tipPercent(badge: any) {
		return Math.round(badge.tipAmount / badge.amount * 100);
	}

	getTimeStringTemp(seconds: number): string {
		const base = moment.duration(seconds, 'seconds').format('m');
		if(seconds < 60) {
			return '<1 min';
		} else {
			return base + ' min' + (base !== 1 ? 's' : '');
		}
	}

	getSecondsAgo(timestamp: number) {
		return moment().unix() - timestamp;
	}

	getTimeString(timestamp: number): string {
		const seconds = this.getSecondsAgo(timestamp);
		const base = moment.duration(seconds, 'seconds').format('m');
		if(seconds < 60) {
			return '<1 min';
		} else {
			return base + ' min' + (base !== 1 ? 's' : '');
		}
	}

	get currentSort() {
		return (find(this.fields, {key: this.sortBy}) as any).label;
	}

	close() {
		this.$emit('close');
	}
}
